/**
 * @generated SignedSource<<5b4bf28349f4afe68cb14779ede545d8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DashboardDiagnosticIsInferredQuery$variables = {
  studentId: string;
};
export type DashboardDiagnosticIsInferredQuery$data = {
  readonly latestCompletedStudentSkillDiagnostic: {
    readonly id: string;
    readonly isInferred: boolean;
  } | null | undefined;
};
export type DashboardDiagnosticIsInferredQuery = {
  response: DashboardDiagnosticIsInferredQuery$data;
  variables: DashboardDiagnosticIsInferredQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "studentId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "studentId",
        "variableName": "studentId"
      }
    ],
    "concreteType": "StudentSkillDiagnosticNode",
    "kind": "LinkedField",
    "name": "latestCompletedStudentSkillDiagnostic",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isInferred",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardDiagnosticIsInferredQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DashboardDiagnosticIsInferredQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a862de3ac228c8c27d1e72134e004245",
    "id": null,
    "metadata": {},
    "name": "DashboardDiagnosticIsInferredQuery",
    "operationKind": "query",
    "text": "query DashboardDiagnosticIsInferredQuery(\n  $studentId: ID!\n) {\n  latestCompletedStudentSkillDiagnostic(studentId: $studentId) {\n    id\n    isInferred\n  }\n}\n"
  }
};
})();

(node as any).hash = "f0bd342f79e52e2913f583b09f74163e";

export default node;
